import api from 'services/api'
import {
  GET_ANNOUNCEMENTS_LIST,
  DELETE_ANNOUNCEMENT,
  CREATE_ANNOUNCEMENT,
  UPDATE_ANNOUNCEMENT,
  GET_ANNOUNCEMENT_DETAIL,
} from '../endpoints'

export const getAnnouncements = async (body) => await api.post(GET_ANNOUNCEMENTS_LIST, body)

export const deleteAnnouncement = async (announcement_id) =>
  await api.delete(DELETE_ANNOUNCEMENT, {data: {announcement_id}})
export const submitAnnouncement = async (values, id) =>
  await api.post(
    id ? UPDATE_ANNOUNCEMENT : CREATE_ANNOUNCEMENT,
    values,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  )


export const getAnnouncementDetail = async (id) =>
  await api.get(`${GET_ANNOUNCEMENT_DETAIL}?announcement_id=${id}`)
